export default __webpack_public_path__ + "static/media/thumbnail.0e04a9c7.webp";